import React from 'react';

export const Cards: React.FC<React.HTMLAttributes<SVGElement>> = (props) => (
  <svg viewBox="2 2 28 28" {...props}>
    <path
      d="M25.929 21.6H9.662a2.162 2.162 0 01-2.073-2.238V8.838A2.162 2.162 0 019.662 6.6h16.267a2.163 2.163 0 012.072 2.238v10.524a2.162 2.162 0 01-2.072 2.238zM9.662 7.7a1.1 1.1 0 00-1.056 1.14v10.524a1.1 1.1 0 001.056 1.14h16.267a1.1 1.1 0 001.056-1.14V8.838a1.1 1.1 0 00-1.056-1.14z"
      fill="currentColor"
    />
    <path
      d="M22.341 25.396H6.074a2.162 2.162 0 01-2.073-2.238v-10.52A2.163 2.163 0 016.074 10.4v1.1a1.1 1.1 0 00-1.056 1.14v10.524a1.1 1.1 0 001.056 1.14h16.267a1.1 1.1 0 001.056-1.14h1.017a2.162 2.162 0 01-2.073 2.232zM8.072 10.782h19.42v1H8.072z"
      fill="currentColor"
    />
  </svg>
);
